import { HouseLot } from '@unreserved-frontend-v2/api/generated/graphql/types'
import { emptyDefault } from '@unreserved-frontend-v2/utils/empty-default'

export const lotDimensions = (lot?: HouseLot | null) => {
  if (!lot || (!lot.frontageDimension?.formattedDimension && !lot.depthDimension?.formattedDimension)) {
    return null
  }

  return `${emptyDefault(lot?.frontageDimension?.formattedDimension)} * ${emptyDefault(
    lot?.depthDimension?.formattedDimension
  )}`
}
